<script>
import { clearCookiesOnLogout } from 'dashboard/store/utils/api';
import claudiaMicrofrontendMixin from './claudiaMicrofrontendMixin';

export default {
  name: 'ClaudiaCompanionWidgetMicrofrontend',
  mixins: [claudiaMicrofrontendMixin],
  data() {
    return {
      remoteName: 'CompanionWidget',
      rootRef: 'companionWidgetRoot',
    };
  },
  computed: {
    // Cached separately from componentProps so the React remote receives the
    // same navigator reference across re-renders. The widget lives globally
    // (mounted in App.vue), so componentProps recomputes on every route
    // change; recreating the navigator literal there would invalidate any
    // React.memo/PureComponent boundary inside the companion that compares
    // props by reference. $router is non-reactive, so this computed is
    // evaluated once for the component's lifetime.
    navigator() {
      return {
        navigate: to => this.$router.push(to),
        goBack: () => this.$router.back(),
      };
    },
    componentProps() {
      const accountId = this.$route.params.accountId;
      const locale = this.$i18n?.locale || 'en';
      const currentUser = this.$store?.getters?.getCurrentUser || {};
      const cognitoAccessToken = currentUser.cognito_access_token || null;
      const instanceId = window.chatwootConfig?.instanceId || null;
      const eddieBaseUrl = currentUser.eddie_base_url || null;

      return {
        accountId: accountId,
        tenantName: this.tenantName,
        tenantProjects: this.tenantProjects,
        eddieWorkspaces: this.eddieWorkspaces,
        locale: locale,
        cognitoAccessToken: cognitoAccessToken,
        instanceId: instanceId,
        eddieBaseUrl: eddieBaseUrl,
        navigator: this.navigator,
        basePath: `/app/accounts/${accountId}/claudia`,
        logout: clearCookiesOnLogout,
      };
    },
  },
  methods: {
    async loadRemote() {
      // Load claudia-app's global stylesheet (Tailwind utilities + design tokens).
      // Without this, ca-* CSS variables are undefined inside the host page.
      await import('claudiaApp/Styles');
      return import('claudiaApp/CompanionWidget');
    },
  },
};
</script>

<template>
  <!-- Empty wrapper — the React widget renders position:fixed bottom-left FAB
       and panel, so this host element does not occupy layout space. Hidden
       while the tenant call is pending; the React side will mount as soon
       as the mixin calls loadRemote(). -->
  <div
    v-show="!tenantError && !tenantLoading"
    ref="companionWidgetRoot"
    class="contents"
  />
</template>
